<script setup lang="ts">
import BaseInput from '~/components/atoms/BaseInput.vue'
import BaseLabel from '~/components/atoms/BaseLabel.vue'

const props = defineProps<{
  modelValue: string
  label: string
  placeholder?: string
  disabled?: boolean
  errorMessage?: string
  autoFocus?: boolean
  required?: boolean
}>()

const emit = defineEmits(['update:modelValue', 'blur'])

const value = computed({
  get: () => props.modelValue || '',
  set: (value: string) => emit('update:modelValue', value),
})
</script>

<template>
  <div>
    <BaseLabel v-if="label" :label="label" />
    <BaseLabel v-if="required" :label="`(${$t('必須')})`" class="required" />
    <BaseInput
      v-model="value"
      :error-message="errorMessage"
      :placeholder="placeholder"
      :disabled="disabled"
      :auto-focus="autoFocus"
      @blur="() => emit('blur')"
    />
  </div>
</template>

<style scoped lang="scss">
.required {
  color: var(--semantic-tokens-danger-default-text);
}
</style>
